import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { bindActionCreators } from 'redux';
import { doAccessAction } from 'store/actions/role-list.actions';
import { ROLES, API_METHODS } from 'config/constants';
import { Loader } from 'components';
import { getProfileData } from 'store/actions/profile.actions';
import { getLocationsData } from 'store/actions/location.actions';
import { getJobTitlesForResearchSite } from 'store/actions/personnel.actions';
import { sendFormData } from 'store/actions/step-registration.actions';
import ComplexSuccessIcon from 'components/SvgIcons/ComplexIcons/success.svg';
import { createSelectList } from 'utils/createSelectList';
import ComplexCrossIcon from 'components/SvgIcons/ComplexIcons/cross.svg';
import { CloseIcon } from 'components';
import { getTextAlertErrorHandler } from 'utils/getTextContext';
import { MODAL_TYPES } from '../constants';
import { LinkForm, FORM_NAME } from './LinkForm';

@connect(
  (
    {
      roleList: { processing = {}, sponsorProfileRequests = {} },
      profileState,
    },
    props,
  ) => ({
    processing: processing[`linkRequest-${props.options.userId}`],
    sponsorProfileRequests,
    profileState: profileState,
  }),
  (dispatch) => ({
    doAccessAction: bindActionCreators(doAccessAction, dispatch),
    getJobTitlesForResearchSite: bindActionCreators(
      getJobTitlesForResearchSite,
      dispatch,
    ),
    getProfileData: bindActionCreators(getProfileData, dispatch),
    getLocationsData: bindActionCreators(getLocationsData, dispatch),
    sendFormData: bindActionCreators(sendFormData, dispatch),
    dispatch,
  }),
)
class LinkModal extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      jobTitlesList: [],
      listLocations: [],
    };
  }

  static propTypes = {
    doAccessAction: PropTypes.func,
    options: PropTypes.shape({
      userRole: PropTypes.string,
      userId: PropTypes.string,
      listDataKey: PropTypes.string,
      actionCb: PropTypes.func,
    }),
    groups: PropTypes.array,
  };

  static defaultProps = {
    options: {},
  };

  componentDidMount() {
    this.loadData();
  }

  onHandleSetJobTitlesForResearchSite = async (value) => {
    const { options: { userId } = {}, dispatch } = this.props;
    const { getJobTitlesForResearchSite } = this.props;
    const url = API_METHODS.RESEARCH_SITES_GET_JOB_TITLES(value);
    const response = await getJobTitlesForResearchSite({
      url,
      processingKey: `linkRequest-${userId}`,
    });
    const jobTitlesList = createSelectList(response.data);

    dispatch(change(FORM_NAME, `jobTitles`, []));
    this.setState({ jobTitlesList });
  };

  loadData = async () => {
    const {
      options: { groups = [], userRole, organizationId, researchSiteId },
      sendFormData,
    } = this.props;

    if (
      groups.includes(ROLES.RESEARCH_SITE) ||
      userRole === ROLES.RESEARCH_SITE
    ) {
      const responseListLocations = await this.props.getLocationsData(
        this,
        'allLocations',
        `${API_METHODS.RESEARCH_SITE_ALL_LOCATIONS_BY_ID_GET(
          organizationId || researchSiteId,
        )}?pageSize=1000`,
      );
      const { data: { items = [] } = {} } = responseListLocations;
      const listLocations = createSelectList(items, true);

      this.setState({ listLocations });
    }
    const isSponsor =
      groups.includes(ROLES.SPONSOR) || userRole === ROLES.SPONSOR;
    const isResearchSite =
      groups.includes(ROLES.RESEARCH_SITE) || userRole === ROLES.RESEARCH_SITE;
    const isRepresentative =
      groups.includes(ROLES.REPRESENTATIVE) ||
      userRole === ROLES.REPRESENTATIVE;
    if (isSponsor || isResearchSite || isRepresentative) {
      const url = API_METHODS.REFERENCE_CATEGORY_BY_ID(
        'SponsorPersonnelJobTitle',
      );
      const response = await sendFormData(url, {}, 'get');
      const jobTitlesList = createSelectList(response.data);

      this.setState({ jobTitlesList });
    }
  };

  handleSubmit = async (values) => {
    const {
      doAccessAction,
      options: { userId, actionCb, groups, handleReloadPage } = {},
      showModal,
    } = this.props;
    const url = API_METHODS.GET_LINKING_REQUESTS;

    if (values.hasOwnProperty('locations')) {
      values.locationId = values.locations;
      delete values.locations;
    }

    const response = await doAccessAction({
      requestMethod: 'post',
      url,
      body: { ...values, recipientId: userId },
      processingKey: `linkRequest-${userId}`,
    });

    if (!response || response.code !== 'success') {
      return showModal(MODAL_TYPES.INFO, {
        withCross: false,
        icon: <ComplexCrossIcon />,
        ...getTextAlertErrorHandler(response.errors || [], {
          data: response.data || {},
          isPersonnel: groups.includes(ROLES.PERSONNEL),
        }),
        additionalClassName: 'p-15',
      });
    }

    showModal(MODAL_TYPES.INFO, {
      withCross: false,
      icon: <ComplexSuccessIcon />,
      text: 'Request is successfully sent',
      body: 'Your request has been sent. You can track the status of the request in your sent requests dashboard',
      additionalClassName: 'p-15',
      style: { maxWidth: '548px' },
      handleReloadPage: handleReloadPage,
    });
    actionCb && actionCb();
  };

  render() {
    const { options: { fullName = '', groups = [], userRole } = {} } =
      this.props;
    const title = groups.includes(ROLES.PERSONNEL)
      ? `Link ${userRole.replace(/([A-Z])/g, ' $1')}`
      : ' Link Personnel to your Organization';

    return (
      <Loader isShow={this.props.processing}>
        <div
          className="white-box p-15 text-left"
          style={{ width: '680px' }}
          data-testid="link-modal"
        >
          <CloseIcon
            onClick={this.props.hideModal}
            className="form-tile-header__close pointer"
            tabIndex={0}
          />
          <div className="montserrat bold fs-16">{title}</div>
          <div
            className="fs-12 mt-2"
            style={{ color: '#6E7780', fontSize: '13px' }}
          >
            {fullName}
          </div>
          <LinkForm
            notesPlaceholder="Enter text"
            onSubmit={this.handleSubmit}
            userRole={userRole}
            jobTitlesList={this.state.jobTitlesList}
            listLocations={this.state.listLocations}
            groups={groups}
            onHandleSetJobTitlesForResearchSite={
              this.onHandleSetJobTitlesForResearchSite
            }
          />
        </div>
      </Loader>
    );
  }
}

export { LinkModal };
